// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";

import HeroSection from "./components/sections/HeroSection/HeroSection";
import MainSection from "./components/sections/MainSection/MainSection";
import FeaturedSection from "./components/sections/FeaturedSection/FeaturedSection";

import Footer from "./components/main/footer/Footer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

import "./fonts/fonts.css"; // Fonts first
import "./App.css";         // Global layout/styles second

const HomePage = () => (
  <div className="home-page">
    <HeroSection />
    <MainSection />
    <FeaturedSection />
  </div>
);

function App() {
  return (
    <div className="app">
      <div className="app-shell">
        <main className="main-content" role="main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;
